import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS = '[IncidentsModul] PostUpdateIncidentsAnzeigeMandantOptions laden';
export const POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_AUSFUEHREN = '[IncidentsModul] PostUpdateIncidentsAnzeigeMandantOptions ausführen';
export const POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_ERFOLGREICH = '[IncidentsModul] PostUpdateIncidentsAnzeigeMandantOptions laden erfolgreich';
export const POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_FEHLER = '[IncidentsModul] PostUpdateIncidentsAnzeigeMandantOptions Ladefehler';
export const POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[IncidentsModul] PostUpdateIncidentsAnzeigeMandantOptions nicht ausgeführt (evtl. Offline)';


export class PostUpdateIncidentsAnzeigeMandantOptionsAction implements Action {
    readonly type = POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS;
        constructor(public incidentsAnzeigeMandantOptions: api.IncidentsAnzeigeMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateIncidentsAnzeigeMandantOptionsAusfuehrenAction implements Action {
    readonly type = POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public incidentsAnzeigeMandantOptions: api.IncidentsAnzeigeMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateIncidentsAnzeigeMandantOptionsErfolgreichAction implements Action {
    readonly type = POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public incidentsAnzeigeMandantOptions: api.IncidentsAnzeigeMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateIncidentsAnzeigeMandantOptionsFehlerAction implements Action {
    readonly type = POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public incidentsAnzeigeMandantOptions: api.IncidentsAnzeigeMandantOptions, public optPayload: any = null) {}
    }
export class PostUpdateIncidentsAnzeigeMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = POST_UPDATE_INCIDENTS_ANZEIGE_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsCommandUpdateIncidentsAnzeigeMandantOptionsActions =
    PostUpdateIncidentsAnzeigeMandantOptionsAction
    | PostUpdateIncidentsAnzeigeMandantOptionsAusfuehrenAction
    | PostUpdateIncidentsAnzeigeMandantOptionsErfolgreichAction
    | PostUpdateIncidentsAnzeigeMandantOptionsFehlerAction
    | PostUpdateIncidentsAnzeigeMandantOptionsNichtAusgefuehrtAction
    ;
